"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTS004_Regist = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const option_1 = require("../../../common/option");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const classes_1 = require("../../base/classes");
const layout_1 = require("../../base/layout");
const action_1 = require("../../menu/action");
const DSTSL001_Regist_Child_1 = require("../DSTSL001/DSTSL001_Regist_Child");
const constant_1 = require("./constant");
const CategoryRadio_1 = require("./DSTS004_Regist_Child/CategoryRadio");
const DTST004_List_Child_1 = require("./DTST004_List_Child");
const DSTS004RegistStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 28px;
	align-items: flex-end;
	justify-content: flex-start;
	flex: 1;
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	padding: ${props => (props.$isTablet || props.$isMobile ? '20px' : '0px')};

	.ql-editor {
		padding: 4px 12px;
	}

	.content-regist-width {
		display: flex;
	}

	.task-label {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		letter-spacing: var(--h5-letter-spacing, -0.02em);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		min-width: 70px;

		${({ $isTablet, $isMobile }) => $isMobile
    ? (0, styled_components_1.css) ``
    : $isTablet
        ? (0, styled_components_1.css) `
						font-size: 14px;
						line-height: 150%;
				  `
        : (0, styled_components_1.css) `
						font-size: var(--h5-font-size, 16px);
						line-height: var(--h5-line-height, 24px);
				  `}
	}

	.border-line {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
	}

	.retry-wrap {
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		border-radius: 4px;
		padding: 0px 9px;
		gap: 0px !important;

		button {
			padding: 6px 0px;
		}
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.regist-content {
		width: 100%;
		overflow: auto;
		height: 100%;
		gap: 28px;
		display: flex;
		flex-direction: column;
		padding-bottom: 28px;
	}

	.content {
		min-height: 265px;
	}

	.border-line {
		padding: 0px 0px 28px 0px;
	}

	.attach_file {
		width: 100%;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	.regist-content {
		width: 100%;
		overflow: auto;
		height: 100%;
		gap: 12px;
		display: flex;
		flex-direction: column;
		padding-bottom: 28px;
	}

	.border-line {
		padding: 0px 0px 12px 0px;
	}

	label {
		span {
			font-size: 12px;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	.task-label {
		max-width: 135px !important;
		min-width: 135px !important;
	}
	.regist-content {
		width: 100%;
		overflow: auto;
		height: 100%;
		gap: 28px;
		display: flex;
		flex-direction: column;
		padding-bottom: 28px;
	}

	.border-line {
		padding: 0px 0px 28px 0px;
	}
`;
exports.DSTS004_Regist = react_1.default.memo(({ id, depths, isReQuestion = false, isTeacher, isPopUp = false, isModify, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const titleRef = react_1.default.createRef();
    const class_id = (0, classes_1.getClassesId)();
    const containerRef = (0, react_1.useRef)(null);
    // 등록 진행 중 표시 — [확인] 연타·두 번 탭으로 같은 질문/재질문이 두 번 저장되는 것을 막는다.
    // (2026-10 DSL00104 재질문 2건 중복 저장 → 스레드 질문·답변 쌍이 밀려 답변 미노출·조교 답변이 질문으로 표시)
    const submittingRef = (0, react_1.useRef)(false);
    const [rootId, setRootId] = (0, react_1.useState)(id);
    const [item, setItem] = (0, react_1.useState)();
    const [title, setTitle] = (0, react_1.useState)();
    const [category, setCategory] = (0, react_1.useState)();
    const [privateValue, setPrivateValue] = (0, react_1.useState)(false);
    const [content, setContent] = (0, react_1.useState)();
    const [textLength, setTextLength] = (0, react_1.useState)(0);
    const [files, setFiles] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const fileMutation = (0, react_query_1.useMutation)(server_1.postFile);
    const registQnaMutation = (0, react_query_1.useMutation)(server_1.registQna);
    const modifyQnaMutation = (0, react_query_1.useMutation)(server_1.modifyQna);
    const { data, refetch } = (0, server_1.useQnaList)({
        ...(!isReQuestion ? { root_id: id } : { id }),
        with_content: true,
    }, 'qna_item');
    (0, react_1.useEffect)(() => {
        if ((title && title.trim() !== '') ||
            (content && content.replace(/<[^>]*>/g, '').trim().length !== 0) ||
            category ||
            (files && files.length > 0)) {
            APP.eventManager.publish('MENU_MOVE_ACTIVE', false);
        }
        else {
            APP.eventManager.publish('MENU_MOVE_ACTIVE', true);
        }
    }, [title, content, category, files]);
    (0, react_1.useEffect)(() => {
        if (isReQuestion) {
            if (isModify) {
                dispatch((0, action_1.changeMobileMenuName)(t('menu.qnaRequestionModify')));
            }
            else {
                dispatch((0, action_1.changeMobileMenuName)(t('menu.qnaRequestion')));
            }
        }
        else {
            if (isModify) {
                dispatch((0, action_1.changeMobileMenuName)(t('menu.qnaModify')));
            }
            else {
                dispatch((0, action_1.changeMobileMenuName)(t('menu.qnaRegist')));
            }
        }
    }, [isModify, isReQuestion]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { found_count, items, total_count } = data;
            if (found_count > 0) {
                const item = items[0];
                if (item)
                    setRootId(item.root_id);
                if (item && isModify) {
                    if (titleRef.current)
                        titleRef.current.value = item.title;
                    setTitle(item.title);
                    setCategory(item.category);
                    setPrivateValue(item.private);
                    setContent(item.content);
                    setFiles(item.files);
                    setItem(item);
                }
                setTotalCount(total_count);
                return;
            }
        }
        if (titleRef.current)
            titleRef.current.value = '';
        setTitle('');
        setContent('');
        setCategory('');
        setPrivateValue(false);
        setItem(undefined);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (id) {
            refetch();
        }
    }, [id]);
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
    };
    const handleAnswerOK = async (index) => {
        if (submittingRef.current)
            return;
        let moveId = id;
        try {
            if (title === undefined || title.trim() === '') {
                alert('제목을 입력해주세요.');
                return;
            }
            if (!isReQuestion && (category === undefined || category === '')) {
                alert('카테고리를 선택해주세요.');
                return;
            }
            if (content.replace(/<[^>]*>/g, '').trim().length === 0) {
                alert('내용을 입력해주세요.');
                return;
            }
            submittingRef.current = true;
            APP.eventManager.publish('SHOW_LOADING', true);
            APP.eventManager.publish('MENU_MOVE_ACTIVE', true);
            let convertAttachFileList = [];
            // 첨부 파일이 있는 경우
            if (files && files.length > 0) {
                const alredyFile = files.filter(file => typeof file === 'string');
                const filterFile = files.filter(file => file instanceof File);
                // 첨부 파일 업로드를 비동기로 실행하고 완료될 때까지 기다립니다.
                if (filterFile && filterFile.length > 0) {
                    // @ts-ignore
                    const data = await fileMutation.mutateAsync(filterFile);
                    convertAttachFileList = [...data.result.link, ...alredyFile];
                }
                else {
                    convertAttachFileList = alredyFile;
                }
            }
            if (id && isModify) {
                const data = {
                    attachments: convertAttachFileList,
                    category,
                    content,
                    private: privateValue,
                    title: title.trim(),
                };
                await modifyQnaMutation.mutateAsync({
                    id,
                    props: data,
                });
                previousPage();
                dispatch((0, action_1.updateMenu)(undefined, { menu: 'qna', detail: 'detail' }, rootId, {
                    depths,
                    isContent: false,
                }));
            }
            else {
                const data = isReQuestion
                    ? {
                        attachments: convertAttachFileList,
                        class_id,
                        content,
                        title: title.trim(),
                        type: constant_1.QNA_TYPE.QUESTION,
                        root_id: id,
                    }
                    : {
                        attachments: convertAttachFileList,
                        category,
                        class_id,
                        content,
                        private: privateValue,
                        title: title.trim(),
                        type: isTeacher ? constant_1.QNA_TYPE.ANSWER : constant_1.QNA_TYPE.QUESTION,
                    };
                try {
                    // ※ 종전에는 여기서 `!content || !category` 면 로딩창을 닫았다. 재질문은 카테고리가 없어 항상 닫혀
                    //   저장 요청 중에 [확인]을 다시 누를 수 있었고 재질문이 두 번 저장됐다(입력 검증은 위에서 끝남).
                    const response = await registQnaMutation.mutateAsync(data);
                    moveId = rootId ? rootId : response.result.id;
                    previousPage();
                    dispatch((0, action_1.updateMenu)(undefined, { menu: 'qna', detail: 'detail' }, moveId, {
                        depths: depths === undefined ? 0 : depths + 2,
                        isContent: false,
                    }));
                }
                catch (error) {
                    throw new Error(error);
                }
            }
        }
        catch (error) {
            alert(error);
        }
        finally {
            submittingRef.current = false;
            APP.eventManager.publish('MENU_MOVE_ACTIVE', false);
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const renderTitleInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo, { key: "DetailTitleInfo", title: isReQuestion
            ? isModify
                ? t('menu.qnaRequestionModify')
                : t('menu.qnaRequestion')
            : isModify
                ? t('menu.qnaModify')
                : t('menu.qnaRegist'), previousPage: previousPage })), [isModify, isReQuestion]);
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'title', className: `fext-field ${isReQuestion ? 'retry-wrap' : ''}` },
        isReQuestion && (react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xs", text: 'supportRoom.req' })),
        react_1.default.createElement(common_1.InputElement, { ref: titleRef, className: "showText", type: "text", placeholder: "\uC81C\uBAA9\uC744 \uC785\uB825\uD558\uC138\uC694", onChange: setTitle, style: {
                backgroundColor: '#ffffff',
                borderStyle: isReQuestion && !isTeacher && 'none',
                outline: isReQuestion && !isTeacher && 'none',
            }, max: 500 }))), [titleRef, setTitle, isTeacher, isReQuestion]);
    const renderTitleWrap = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { key: 'title-wrap', className: "field-global-001" }, renderTitle)), [renderTitle]);
    const renderCategoryRadio = (0, react_1.useMemo)(() => !isReQuestion && (react_1.default.createElement(CategoryRadio_1.CategoryRadio, { key: 'category', defaultCategory: category, setCategory: setCategory, defaultPrivate: privateValue, setPrivate: setPrivateValue })), [category, privateValue]);
    const renderContent = (0, react_1.useMemo)(() => (react_1.default.createElement(DSTSL001_Regist_Child_1.RegistContent, { key: 'content', contentName: "\uB0B4\uC6A9", defaultValue: !isModify ? undefined : item?.content, setValue: setContent, handlerTextLength: setTextLength, isTeacher: isTeacher, containerRef: containerRef, minHeight: '265px' })), [isReQuestion, item]);
    const renderFileAttach = (0, react_1.useMemo)(() => (react_1.default.createElement(option_1.FileAttach, { key: 'attach-file', id: "attach_file", className: isMobile
            ? 'btn_tur mobile-xs'
            : isTablet
                ? 'btn_tur mobile-sm'
                : 'btn_tur xmd', isRegist: true, isQnA: true, fileList: files, setAttachFileList: setFiles })), [files]);
    const questionListPage = () => {
        dispatch((0, action_1.updateMenu)(undefined, { menu: 'qna', detail: 'question_list' }, rootId, {
            isModify,
            isReQuestion: true,
            depths: depths,
            isHistory: true,
            isPopUp: true,
        }));
    };
    // 모바일일때 질문이력 보기 버튼
    const renderQuestionList = (0, react_1.useMemo)(() => depths > 0 && (react_1.default.createElement(common_1.Button, { key: 'renderQuestionList', className: "btn_line_tur mobile-xs", text: t('supportRoom.showQuestionList'), option: {
            buttonBeforeIcon: {
                show: true,
                name: 'question',
                size: 16,
                color: Colors_1.Colors.tur,
            },
        }, styles: { buttonWrap: { width: '100%', padding: '8px 16px', gap: '4px' } }, onClick: questionListPage })), [totalCount]);
    const renderQnAListTable = (0, react_1.useMemo)(() => (react_1.default.createElement(DTST004_List_Child_1.QnAListTable, { key: "table", id: rootId, isPopUp: isPopUp, isRetry: true, isHistory: true, hideDetail: isPopUp ? false : true })), [rootId, isPopUp]);
    if (isPopUp) {
        return (react_1.default.createElement(DSTS004RegistStyled, { className: "dsts004_regist_popup", "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement(layout_1.MobileTabLayout, { tabList: [
                    {
                        id: 1,
                        component: [renderQnAListTable],
                        styles: { gap: '12px', display: 'flex', flexDirection: 'column' },
                    },
                ], hideHr: true, test_id: id })));
    }
    if (isMobile) {
        return (react_1.default.createElement(DSTS004RegistStyled, { className: "dsts004_regist_mobile", "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement(layout_1.MobileTabLayout, { tabList: [
                    {
                        id: 1,
                        component: [
                            renderQuestionList,
                            renderCategoryRadio,
                            renderTitleWrap,
                            renderContent,
                            renderFileAttach,
                        ],
                        styles: { gap: '12px', display: 'flex', flexDirection: 'column' },
                    },
                ], showNav: false, showPageButton: true, submitAssignment: handleAnswerOK })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DSTS004RegistStyled, { className: "dsts004_regist wrapper-padding", "$isTablet": isTablet, "$isMobile": isMobile },
            isDesktop && renderTitleInfo,
            react_1.default.createElement("div", { className: "regist-content", ref: containerRef },
                depths !== undefined && (react_1.default.createElement("div", { className: "field-global-001" },
                    react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.questionList')),
                    renderQnAListTable)),
                react_1.default.createElement("div", { className: "field-global-001 border-line" },
                    react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.title')),
                    renderTitle),
                renderCategoryRadio,
                renderContent,
                renderFileAttach,
                react_1.default.createElement("div", { className: "btn-container", style: { gap: 6 } },
                    react_1.default.createElement(common_1.Button, { className: "btn_white xmd", text: t('common.cancel'), onClick: previousPage }),
                    react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: t('common.okay'), onClick: () => handleAnswerOK() }))))));
});
